import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Box, Divider, List, ListItem, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { THEME_TYPE } from "../../common/const";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { ThemeLight } from "../../state/ThemeLight";
import ExtensionIcon from "@mui/icons-material/Extension";

const navMenus: NavMenuContent[] = [
  {
    title: "Home",
    link: "/",
    icon: "",
    implemented: true,
    children: [],
  },
  {
    title: "Blockchain",
    link: "#",
    icon: "",
    implemented: true,
    children: [
      {
        title: "Transaction",
        link: "/txs",
        implemented: true,
        divider: false,
        smallTxt: "",
      },
      {
        title: "Pending Transaction",
        link: "/txsPending",
        implemented: true,
        divider: false,
        smallTxt: "",
      },
      {
        title: "Contract Internal Transactions",
        link: "/txsInternal",
        implemented: true,
        divider: false,
        smallTxt: "",
      },
      {
        title: "Beacon Deposits",
        link: "/txsBeaconDeposit",
        implemented: false,
        divider: false,
        smallTxt: "",
      },
      {
        title: "Beacon Withdrawals",
        link: "/txsBeaconWithdraw",
        divider: true,
        implemented: false,
        smallTxt: "",
      },
      {
        title: "View Blocks",
        link: "/blocks",
        divider: false,
        smallTxt: "",
        implemented: true,
      },
      {
        title: "Forked Blocks (Reorgs)",
        link: "/blocks_forked",
        divider: false,
        smallTxt: "",
        implemented: true,
      },
      {
        title: "Uncles",
        link: "/uncles",
        divider: true,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Top Accounts",
        link: "/accounts",
        divider: false,
        smallTxt: "",
        implemented: true,
      },
      {
        title: "Verified Contracts",
        link: "/contractsVerified",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
    ],
  },
  {
    title: "Tokens",
    link: "#",
    icon: "",
    implemented: true,
    children: [
      {
        title: "Top Tokens",
        link: "/tokens",
        divider: false,
        smallTxt: "(UIA-20)",
        implemented: true,
      },
      {
        title: "Token Transfers",
        link: "/tokentxns ",
        divider: false,
        smallTxt: "(UIA-20)",
        implemented: true,
      },
    ],
  },
  {
    title: "NFAs",
    link: "#",
    icon: "",
    implemented: true,
    children: [
      {
        title: "Top NFAs",
        link: "/nft-top-contracts",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Top Mints",
        link: "/nft-top-mints",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Latest Trades",
        link: "/nft-trades",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Latest Transfers",
        link: "/nft-transfers",
        divider: false,
        smallTxt: "",
        implemented: true,
      },
      {
        title: "Latest Mints",
        link: "/nft-latest-mints",
        divider: false,
        smallTxt: "",
        implemented: true,
      },
    ],
  },
  {
    title: "Resources",
    link: "#",
    icon: "",
    implemented: true,
    children: [
      {
        title: "Charts And Stats",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Top Statistics",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Leaderboard",
        link: "/",
        divider: true,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Directory",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Newsletter",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Knowledge Base",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
    ],
  },
  {
    title: "Developers",
    link: "#",
    implemented: true,
    icon: "",
    children: [
      {
        title: "API Plans",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "API Documentation",
        link: "/",
        divider: true,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Code Reader ",
        link: "/",
        divider: false,
        smallTxt: "Beta",
        implemented: false,
      },
      {
        title: "Verify Contract",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Similar Contract Search",
        link: "/",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Smart Contract Search",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Contract Diff Checker",
        link: "#",
        divider: true,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Vyper Online Compiler",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Bytecode to Opcode",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
      {
        title: "Broadcast Transaction",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
    ],
  },
  // {
  //   title: "More",
  //   link: "#",
  //   icon: "",
  //   children: [
  //     {
  //       title: "API Plans",
  //       link: "/",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "API Documentation",
  //       link: "/",
  //       divider: true,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Code Reader ",
  //       link: "/",
  //       divider: false,
  //       smallTxt: "Beta",
  //     },
  //     {
  //       title: "Verify Contract",
  //       link: "/",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Similar Contract Search",
  //       link: "/",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Smart Contract Search",
  //       link: "#",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Contract Diff Checker",
  //       link: "#",
  //       divider: true,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Vyper Online Compiler",
  //       link: "#",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Bytecode to Opcode",
  //       link: "#",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //     {
  //       title: "Broadcast Transaction",
  //       link: "#",
  //       divider: false,
  //       smallTxt: "",
  //     },
  //   ],
  // },
  {
    title: "",
    link: "#",
    icon: "",
    implemented: true,
    children: [],
  },
  {
    title: "Sign In",
    link: "login",
    icon: <AccountCircleIcon fontSize="small" className="mr-2" />,
    implemented: true,
    children: [],
  },
  {
    title: "",
    link: "#",
    icon: "",
    implemented: true,
    children: [],
  },
  {
    title: "Shard A",
    link: "#",
    icon: <ExtensionIcon fontSize="small" className="mr-2" />,
    implemented: true,
    children: [
      {
        title: "Shard A",
        link: "#",
        divider: false,
        smallTxt: "",
        implemented: false,
      },
    ],
  },
];

const Header = () => {
  const { quoteUSD, selectedShard, shards, handleChangeShard } = useUpcxChain();
  const { sessionKey, username } = useDeveloperContext();

  const location = useLocation();
  const navigate = useNavigate();

  const [themeLight, setThemeLight] = useRecoilState(ThemeLight);

  const [anchorTheme, setAnchorTheme] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorUPC, setAnchorUPC] = React.useState<null | HTMLElement>(null);

  const [menu, setMenu] = useState<NavMenuContent[]>(navMenus);

  useEffect(() => {
    let menu = [...navMenus];
    if (sessionKey !== undefined && sessionKey !== "") {
      menu.splice(menu.length - 3, 1, {
        title: username,
        link: "login",
        icon: <AccountCircleIcon fontSize="small" className="mr-2" />,
        implemented: true,
        children: [
          {
            title: "Account Overview",
            link: "/myaccount",
            divider: false,
            smallTxt: "",
            implemented: true,
          },
          {
            title: "Account Settings",
            link: "/mysettings",
            divider: false,
            smallTxt: "",
            implemented: true,
          },
          {
            title: "Public Profile",
            link: "/myprofile",
            divider: true,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "Watch List",
            link: "/myaddress",
            divider: false,
            smallTxt: "",
            implemented: true,
          },
          {
            title: "Private Name Tags",
            link: "#",
            divider: false,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "Txn Private Notes",
            link: "#",
            divider: false,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "Token Ignore List",
            link: "#",
            divider: false,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "Advanced Filter",
            link: "#",
            divider: true,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "API Keys",
            link: "/myapikey",
            divider: false,
            smallTxt: "",
            implemented: true,
          },
          {
            title: "Verified Addresses",
            link: "#",
            divider: false,
            smallTxt: "",
            implemented: false,
          },
          {
            title: "Custom ABIs",
            link: "#",
            divider: false,
            smallTxt: "",
            implemented: false,
          },
        ],
      });
    }

    if (shards && selectedShard) {
      menu[menu.length - 1].title = selectedShard.name;
      menu[menu.length - 1].children = [];
      for (let i = 0; i < shards.length; i++) {
        menu[menu.length - 1].children.push({
          title: shards[i].name,
          link: "#",
          divider: false,
          smallTxt: "",
          implemented: false,
          hasClickHandler: true,
          etc: shards[i].shardId,
        });
      }
    }

    setMenu(menu);
  }, [sessionKey, username, shards, selectedShard]);

  const openThem = Boolean(anchorTheme);
  const openUPC = Boolean(anchorUPC);
  const handleThemeClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorTheme(event.currentTarget);
  };
  const handleThemeClose = () => {
    setAnchorTheme(null);
  };

  const handleUPCClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorUPC(event.currentTarget);
  };
  const handleUPCClose = () => {
    setAnchorUPC(null);
  };

  const handleTheme = (themeType: string) => {
    if (themeType === THEME_TYPE.DARK) {
      setThemeLight(false);
    } else {
      setThemeLight(true);
    }
  };

  return (
    <>
      <section
        id="masterTopBar"
        className="d-none d-lg-block sticky-top bg-white border-bottom py-1"
      >
        <div className="__top-banner container-xxl d-flex align-items-center justify-content-between">
          <div
            id="ethPrice"
            className="d-flex align-items-sm-center gap-4 w-100 fs-sm"
          >
            <div className="text-muted">
              <span className="text-muted">UPC Price:</span>{" "}
              <a href="/chart/upcxprice">
                ${quoteUSD?.marketCapPrice.toLocaleString()}
              </a>
              <span data-bs-toggle="tooltip" data-bs-placement="top">
                {quoteUSD && quoteUSD?.marketCapRisePercentage > 0 ? (
                  <span className="text-success">
                    {" "}
                    (+{quoteUSD?.marketCapRisePercentage.toFixed(2)}%)
                  </span>
                ) : (
                  <span className="text-danger">
                    {" "}
                    ({quoteUSD?.marketCapRisePercentage.toFixed(2)}%)
                  </span>
                )}
              </span>
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center gap-2">
            <div id="divThemeSetting" className="dropdown">
              <button
                className="btn btn-lg btn-white text-primary content-center"
                onClick={handleThemeClick}
              >
                <span className="theme-btn-main">
                  {themeLight ? (
                    <LightModeOutlinedIcon fontSize="small" />
                  ) : (
                    <DarkModeOutlinedIcon fontSize="small" />
                  )}
                </span>
              </button>
              <Menu
                anchorEl={anchorTheme}
                id="divThemeSettingToggle"
                open={openThem}
                onClose={handleThemeClose}
                onClick={handleThemeClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    handleUPCClose();
                    handleTheme(THEME_TYPE.LIGHT);
                  }}
                  style={{
                    fontSize: "0.8rem",
                  }}
                >
                  <LightModeOutlinedIcon fontSize="small" />
                  &nbsp;Light
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleUPCClose();
                    handleTheme(THEME_TYPE.DARK);
                  }}
                  style={{
                    fontSize: "0.8rem",
                  }}
                >
                  <DarkModeOutlinedIcon fontSize="small" />
                  &nbsp;Night
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={handleUPCClose}
                  style={{
                    fontSize: "0.8rem",
                  }}
                >
                  <SettingsOutlinedIcon fontSize="small" />
                  &nbsp;Settings
                  <ArrowRightAltOutlinedIcon />
                </MenuItem>
              </Menu>
            </div>
            <div id="divTestNet" className="dropdown">
              <button
                className="btn btn-lg btn-white text-primary content-center"
                onClick={handleUPCClick}
              >
                <img
                  src={
                    themeLight
                      ? "/assets/img/logo_black.png"
                      : "/assets/img/logo_white.png"
                  }
                  alt="UPCX logo"
                  width={20}
                />
              </button>
              <Menu
                anchorEl={anchorUPC}
                id="divTestNetToggle"
                open={openUPC}
                onClose={handleUPCClose}
                onClick={handleUPCClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleUPCClose}>
                  <Link
                    to="https://explorer.upcx.org"
                    className={
                      process.env.REACT_APP_IS_DEV === "false" &&
                      process.env.REACT_APP_IS_MAIN === "true"
                        ? ""
                        : "dropdown-item"
                    }
                  >
                    UPCX Mainnet
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleUPCClose}>
                  <Link
                    to="https://explorer-testnet.upcx.org"
                    className={
                      process.env.REACT_APP_IS_DEV === "false" &&
                      process.env.REACT_APP_IS_MAIN === "false"
                        ? ""
                        : "dropdown-item"
                    }
                  >
                    UPCX Testnet
                  </Link>
                </MenuItem>
                {process.env.REACT_APP_IS_DEV === "true" && (
                  <MenuItem onClick={handleUPCClose}>
                    <Link to="https://explorer-devnet.upcx.org">
                      UPCX Devnet
                    </Link>
                  </MenuItem>
                )}
              </Menu>
            </div>
          </div>
        </div>
      </section>

      <header className="header border-bottom d-print-none">
        <nav className="navbar navbar-expand-lg navbar-light py-3 py-lg-0">
          <div className="container-xxl position-relative">
            <Link to="/" className="navbar-brand">
              <img
                src={
                  themeLight
                    ? "/assets/img/logo.png"
                    : "/assets/img/logo_title_white.png"
                }
                alt="UPCer Logo"
                width={150}
              />
            </Link>
            <div className="collapse navbar-collapse justify-content-end">
              <List className="navbar-nav gap-1 gap-lg-0 pt-0 pb-0 pt-lg-0">
                {menu.map((menu, index) =>
                  menu.title.length > 0 ? (
                    <ListItem
                      className="nav-item dropdown"
                      disablePadding
                      key={index}
                    >
                      <Link
                        to={menu.link}
                        className="nav-link white-space-nowrap"
                      >
                        {menu.icon ? menu.icon : ""}
                        {menu.title}
                        {menu.children.length > 0 ? (
                          <KeyboardArrowDownIcon fontSize="small" />
                        ) : (
                          ""
                        )}
                      </Link>

                      {menu.children.length > 0 && (
                        <List className="dropdown-menu dropdown-menu-border">
                          {menu.children.map((subMenu, subIndex) => (
                            <Box key={subIndex}>
                              <ListItem disablePadding>
                                <Link
                                  to={subMenu.link}
                                  className="dropdown-item"
                                  style={{
                                    color: subMenu.implemented
                                      ? "inherit"
                                      : "gray",
                                  }}
                                  onClick={() => {
                                    if (subMenu.hasClickHandler) {
                                      if (
                                        location.pathname.startsWith("/tx/") ||
                                        location.pathname.startsWith(
                                          "/block/"
                                        ) ||
                                        location.pathname.startsWith(
                                          "/address/"
                                        ) ||
                                        location.pathname.startsWith(
                                          "/contract/"
                                        )
                                      ) {
                                        if (
                                          selectedShard?.shardId !== subMenu.etc
                                        ) {
                                          window.location.href = "/";
                                        }
                                      }

                                      handleChangeShard(subMenu.etc!);
                                    }
                                  }}
                                >
                                  {subMenu.title}

                                  {subMenu.smallTxt ? (
                                    <span className="small text-muted">
                                      &nbsp;{subMenu.smallTxt}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </Link>
                                <Divider />
                              </ListItem>
                              {subMenu.divider ? (
                                <Divider component="li" />
                              ) : (
                                ""
                              )}
                            </Box>
                          ))}
                        </List>
                      )}
                    </ListItem>
                  ) : (
                    <ListItem
                      key={index}
                      className="nav-item align-self-center d-none d-lg-block"
                      disablePadding
                    >
                      <span className="text-secondary">|</span>
                    </ListItem>
                  )
                )}
              </List>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
